import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "grid grid-cols-2 gap-3.5" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "flex flex-col gap-4 mt-4" };
const _hoisted_4 = { class: "flex justify-between items-center" };
const _hoisted_5 = { class: "text-sm text-surface-900 font-semibold" };
const _hoisted_6 = { class: "text-sm text-surface-900 font-semibold mb-5" };
const _hoisted_7 = { class: "flex flex-col gap-7" };
import { ref, computed } from "vue";
import Popover from "primevue/popover";
import ToggleSwitch from "primevue/toggleswitch";
import ThresholdStepper from "./ThresholdStepper.vue";
import { Popover as GlobalPopover } from "@/utils/globalPassThrough";
import { mergePt } from "@/utils/util";
import { OVERVIEW_THRESHOLD_SETTING_KEYS } from "@/utils/const";
import { $tf } from "@/plugins/i18n";
import { useOverviewThresholdSettingStore } from "@/store/pinia/useOverviewThresholdSettingStore";
var INTERVAL;
(function (INTERVAL) {
    INTERVAL["DAILY"] = "daily";
    INTERVAL["WEEKLY"] = "weekly";
})(INTERVAL || (INTERVAL = {}));
export default /*@__PURE__*/ _defineComponent({
    __name: 'SettingsPopover',
    props: {
        selectedInterval: {}
    },
    emits: ["update:selectedInterval"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const intervals = computed(() => [
            {
                label: $tf("interval.label.daily|Napi"),
                value: INTERVAL.DAILY,
                icon: "fa-solid fa-clock",
            },
            {
                label: $tf("interval.label.weekly|Heti"),
                value: INTERVAL.WEEKLY,
                icon: "fa-solid fa-calendar",
            },
        ]);
        const popoverRef = ref();
        __expose({
            popoverRef,
        });
        // Threshold settings - Overall logged time
        const overviewThresholdSettingStore = useOverviewThresholdSettingStore();
        const { updateTresholdSetting, updateShowWeekends } = overviewThresholdSettingStore;
        const selectedOverallLoggedTime = computed(() => {
            return overviewThresholdSettingStore.overallLoggedTimeComplianceErrorThreshold;
        });
        const updateSelectedOverallLoggedTime = (value) => {
            updateTresholdSetting(OVERVIEW_THRESHOLD_SETTING_KEYS.OVERALL_LOGGED_TIME_COMPLIANCE_ERROR_THRESHOLD, value);
        };
        const selectedProjectLoggedTime = computed(() => {
            return overviewThresholdSettingStore.projectLoggedTimeComplianceErrorThreshold;
        });
        const updateSelectedProjectLoggedTime = (value) => {
            updateTresholdSetting(OVERVIEW_THRESHOLD_SETTING_KEYS.PROJECT_LOGGED_TIME_COMPLIANCE_ERROR_THRESHOLD, value);
        };
        const selectedShowWeekends = computed(() => {
            return overviewThresholdSettingStore.showWeekends;
        });
        const updateSelectedShowWeekends = (value) => {
            updateShowWeekends(value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Popover), {
                ref_key: "popoverRef",
                ref: popoverRef,
                pt: _unref(mergePt)(_unref(GlobalPopover), {
                    root: {
                        class: '!py-3 !px-3.5 w-[350px]',
                    },
                })
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervals.value, (interval) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: interval.value,
                                class: _normalizeClass(["flex flex-col gap-3 justify-center items-center bg-surface-50 rounded-md p-4 border border-surface-200 cursor-pointer", {
                                        'bg-primary-50 border-primary-500': __props.selectedInterval === interval.value,
                                    }]),
                                onClick: ($event) => (emit('update:selectedInterval', interval.value))
                            }, [
                                _createElementVNode("i", {
                                    class: _normalizeClass(["text-surface-500 text-lg", {
                                            [interval.icon]: true,
                                            '!text-primary-500': __props.selectedInterval === interval.value,
                                        }])
                                }, null, 2),
                                _createElementVNode("span", {
                                    class: _normalizeClass(["text-sm text-surface-500 font-semibold", {
                                            '!text-primary-500': __props.selectedInterval === interval.value,
                                        }])
                                }, _toDisplayString(interval.label), 3)
                            ], 10, _hoisted_2));
                        }), 128))
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "h-[1px] bg-surface-100 my-3.5 -mx-3.5" }, null, -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref($tf)("settingsPopover.showWeekends|Hétvégék elrejtése")), 1),
                            _createVNode(_unref(ToggleSwitch), {
                                "model-value": selectedShowWeekends.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => updateSelectedShowWeekends(value))
                            }, null, 8, ["model-value"])
                        ]),
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref($tf)("timeManagementOverview.settingsPopover.title|Hibaküszöb opciók")), 1),
                            _createElementVNode("div", _hoisted_7, [
                                _createVNode(ThresholdStepper, {
                                    title: _unref($tf)('timeManagementOverview.settingsPopover.overallLoggedTimeCompliance|Teljes logolt idő hibahatár'),
                                    "selected-value": selectedOverallLoggedTime.value,
                                    "onUpdate:selectedValue": updateSelectedOverallLoggedTime
                                }, null, 8, ["title", "selected-value"]),
                                _createVNode(ThresholdStepper, {
                                    title: _unref($tf)('timeManagementOverview.settingsPopover.projectLoggedTimeCompliance|Projekt logolt idő hibahatár'),
                                    "selected-value": selectedProjectLoggedTime.value,
                                    "onUpdate:selectedValue": updateSelectedProjectLoggedTime
                                }, null, 8, ["title", "selected-value"])
                            ])
                        ])
                    ])
                ]),
                _: 1
            }, 8, ["pt"]));
        };
    }
});
